<template>
    <section class="wizards-body">
        <Step0Introduction v-if="isInSteps === false" />
        <router-view v-else />
        <Transition>
            <SmallLoader v-if="isBusy" />
        </Transition>
    </section>
</template>
<script charset="utf-8">
    import Step0Introduction from "./Steps/Step0Introduction.vue";
    import SmallLoader from "../../BasicControls/SmallLoader.vue";
    import wizardNewCadenceService from "../../../services/wizard.new.cadence.service";

    export default {
        name: "NewCadenceWizards",
        components: {
            Step0Introduction,
            SmallLoader
        },
        computed: {
            isInSteps() {
                return this.$route.name.toLowerCase() === "newcadencewizardssteps";
            },
            isBusy() {
                return this.$store.state.wizardNewCadence.isBusy;
            }
        },
        async mounted() {
            try {
                let response = await wizardNewCadenceService.checkIfClientHasTransmission();
                if (response.status !== 200) {
                    return;
                }

                this.$store.state.wizardNewCadence.clientHasTransmission = response.data;

            }
            finally {
                console.log("finaly");
            }
        }
    }
</script>
<style lang="scss">
    .wizards-body {
        padding: 20px 25px;
        background: linear-gradient(146.23deg, #d5e0f5 0%, #ffffff 100%);
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: 24px 40px 120px rgba(0, 8, 44, 0.32);
        border-radius: 12px;
        position: relative;
        width: 70vw;
    }
</style>